import React, { useState } from 'react';
import Select from 'react-select';

const ShippingDtlsTab = () => {
const [disableHawbIssuedBy, setDisableHawbIssuedBy] = useState(true);

// Placeholder options (replace these with actual data)
const joborderOptions = [];
const agentOptions = [];
const customerOptions = [];
const quotationOptions = [];

return (
<>
    <form>
        <div className="row border-bottom-2 pb-3">
            <div className="col-md-12">
                <div className="card px-3 py-2">
                    <div className="row">
                        {/* Left Column */}

                        <div className="col-md-6 mt-2">
                            <div className="d-flex justify-content-between">
                                <div className='d-flex flex-grow-1 flex-column'>
                                    <label htmlFor="" className='form-label   mb-0'>
                                        HAWB No.
                                    </label>
                                    <div className="icon-forms mb-3 mb-sm-0">
                                        <input type="text" className="form-control form-control-sm" name='order_no' />
                                    </div>
                                </div>
                                <div className='ms-2 d-flex flex-grow-1 flex-column'>
                                    <label htmlFor="" className='form-label    mb-0'>
                                        Date
                                    </label>
                                    <div className="icon-forms mb-3 mb-sm-0">
                                        <input type="date" className="form-control form-control-sm" name='search_by' />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 mt-2">
                            <div className="d-flex justify-content-between">
                                <div className='d-flex flex-grow-1 flex-column'>
                                    <label htmlFor="" className='form-label   mb-0'>
                                        Execution Place
                                    </label>
                                    <div className="icon-forms mb-3 mb-sm-0">
                                        <input type="text" className="form-control form-control-sm" name='order_no' />
                                    </div>
                                </div>
                                <div className='ms-2 d-flex flex-grow-1 flex-column'>
                                    <label htmlFor="" className='form-label    mb-0'>
                                        Date
                                    </label>
                                    <div className="icon-forms mb-3 mb-sm-0">
                                        <input type="date" className="form-control form-control-sm" name='search_by' />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row mt-5">

                            <hr className='mb-1 ' />
                            <h4 className=' text-label-red'>Consol Detail</h4>
                            <hr />

                        </div>

                        <div className="col-md-6 mt-2">
                            <div className=' d-flex flex-grow-1 flex-column'>
                                <label htmlFor="" className='form-label    mb-0'>
                                    Consolidate At
                                </label>
                                <div className="icon-forms mb-3 mb-sm-0">
                                    <Select className='mt-2 custom-selector ' options={[{ label: "Delhi" ,
                                        value: "Delhi" }, { label: "Mumbai" , value: "Mumbai" }]} //
                                        defaultValue={{ label: "Origin1", value: "Origin1" }} />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 mt-2">
                            <div className="d-flex justify-content-between align-items-start">
                                {/* Console No. Section */}
                                <div className="d-flex flex-column me-2 flex-grow-1">
                                    <label htmlFor="console-select" className="form-label   mb-1">
                                        Console No.
                                    </label>
                                    <Select id="console-select" className="mt-1 custom-selector" options={[ {
                                        label: "C 1" , value: "C 1" }, { label: "C 2" , value: "C 2" } ]}
                                        defaultValue={{ label: "C 1", value: "C 1" }} />
                                </div>
                                {/* Date Section */}
                                <div className="d-flex flex-column flex-grow-1">
                                    <label htmlFor="date-input" className="form-label   mb-1">
                                        Date
                                    </label>
                                    <input type="date" id="date-input" className="form-control form-control-sm mt-1"
                                        name="search_by" />
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 mt-2">
                            <div className="d-flex justify-content-between align-items-start">
                                {/* AWB No. Section */}
                                <div className="d-flex flex-column flex-grow-1 me-2">
                                    <label htmlFor="awb-select" className="form-label   mb-1">
                                        AWB No.
                                    </label>
                                    <Select id="awb-select" className="mt-1 custom-selector" options={[ { label: "AWB_1"
                                        , value: "AWB_1" }, { label: "AWB_2" , value: "AWB_2" } ]}
                                        defaultValue={{ label: "AWB_1", value: "AWB_1" }} />
                                </div>
                                {/* Date Section */}
                                <div className="d-flex flex-column flex-grow-1">
                                    <label htmlFor="date-input" className="form-label   mb-1">
                                        Date
                                    </label>
                                    <input type="date" id="date-input" className="form-control form-control-sm mt-1"
                                        name="search_by" />
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 mt-2">
                            <div className="d-flex justify-content-between">
                                <div className="d-flex flex-column flex-grow-1 me-2">
                                    <label htmlFor="" className='form-label   mb-0'>
                                        Place of Exec.
                                    </label>
                                    <div className="icon-forms mt-0 mb-sm-0">
                                        <Select className="mt-2 custom-selector " options={[{ label: "Delhi" ,
                                            value: "Delhi" }, { label: "Mumbai" , value: "Mumbai" }]}
                                            defaultValue={{ label: "Delhi", value: "Delhi" }} />
                                    </div>

                                </div>
                                <div className="d-flex flex-column flex-grow-1">
                                    <label htmlFor="" className='form-label    mb-1'>
                                        Date
                                    </label>
                                    <div className="icon-forms mt-1 mb-sm-0">
                                        <input type="date" className="form-control form-control-sm" name='search_by' />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* <div className="row mt-5">
                            <hr className='mb-1' />
                            <h4 className='text-label-red '>Co - Load</h4>
                            <hr />
                        </div>

                        <div className="col-md-6 mt-2">
                            <div className='d-flex flex-grow-1 flex-column'>
                                <label htmlFor="" className='form-label    mb-0'>
                                    Origin
                                </label>
                                <div className="icon-forms mt-2 mb-sm-0">
                                    <select className="form-control form-control-sm">
                                        <option value="" selected>Not Applicable</option>
                                        <option value="">In</option>
                                        <option value="">Out</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 mt-2">
                            <div className='d-flex flex-grow-1 flex-column'>
                                <label htmlFor="" className='form-label    mb-0'>
                                    Agent Name
                                </label>
                                <div className="icon-forms mb-3 mb-sm-0">
                                    <Select className="mt-2 custom-selector " options={[{ label: "A 1" , value: "A 1" },
                                        { label: "A 2" , value: "A 2" }]}
                                        defaultValue={{ label: "A 1", value: "A 1" }} />
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 mt-4">
                            <div className="d-flex justify-content-between align-items-start">
                                <div className='d-flex flex-grow-1 flex-column'>
                                    <label htmlFor="" className='form-label   mb-0'>
                                        Agent AWB No.
                                    </label>
                                    <div className="icon-forms mb-3 mb-sm-0 me-2">
                                        <input type="text" name="" id="" className='form-control form-control-sm' />
                                    </div>

                                </div>
                                <div className='d-flex flex-grow-1 flex-column'>
                                    <label htmlFor="" className='form-label    mb-0'>
                                        Date
                                    </label>
                                    <div className="icon-forms mb-3 mb-sm-0">
                                        <input type="date" className="form-control form-control-sm" name='search_by' />
                                    </div>
                                </div>
                            </div>
                        </div> */}

                        <div className="row mt-5">
                            <hr className='mb-1' />
                            <h4 className=' text-label-red'>Other Details</h4>
                            <hr />
                        </div>

                        <div className="col-md-6 mt-2">
                            <label className="form-label mb-0">SAWB No.</label>
                            <input type="text" className="form-control form-control-sm mt-2" />
                        </div>

                        <div className="col-md-6 mt-2">
                            <label className="form-label mb-0">Shipper's Ref.</label>
                            <input type="text" className="form-control form-control-sm mt-2" />
                        </div>

                        <div className="col-md-6 mt-2">
                            <label className="form-label mb-0">Lead No.</label>
                            <Select className="mt-2 custom-selector" options={[ { label: "Lead 1" , value: "Lead 1" }, {
                                label: "Lead 2" , value: "Lead 2" } ]}
                                defaultValue={{ label: "Lead 1", value: "Lead 1" }} />
                        </div>

                        <div className="col-md-6 mt-2">
                            <label className="form-label mb-0">Sales Person</label>
                            <Select className="mt-2 custom-selector" options={[ { label: "SP 1" , value: "SP 1" }, {
                                label: "SP 2" , value: "SP 2" } ]} defaultValue={{ label: "SP 1", value: "SP 1" }} />
                        </div>

                        <div className="col-md-6 mt-2">
                            <label className="form-label mb-0">PO/Con Ref No.</label>
                            <input type="text" className="form-control form-control-sm mt-2" />
                        </div>

                        <div className="col-md-6 mt-2">
                            <label className="form-label mb-0">CCL Job No.</label>
                            <input type="text" className="form-control form-control-sm mt-2" />
                        </div>

                        <div className="col-md-6 mt-2">
                            <label className="form-label mb-0">Business Dims.</label>
                            <Select className="mt-2 custom-selector" options={[ { label: "BD 1" , value: "BD 1" }, {
                                label: "BD 2" , value: "BD 2" } ]} defaultValue={{ label: "BD 1", value: "BD 1" }} />
                        </div>

                        <div className="col-md-6 mt-2">
                            <label className="form-label mb-0">AMS HAWB No.</label>
                            <input type="text" className="form-control form-control-sm mt-2" />
                        </div>

                        <div className="col-md-6 mt-2">
                            <label className="form-label mb-0">Last Free Date</label>
                            <input type="date" className="form-control form-control-sm mt-2" />
                        </div>

                        <div className="col-md-6 mt-2">
                            <label className="form-label mb-0">G.O. Date</label>
                            <input type="date" className="form-control form-control-sm mt-2" />
                        </div>

                        <div className="col-md-3 mt-2 d-flex flex-column align-items-baseline">
                            <label className="form-label mb-0">Short Landed</label>
                            <input type="checkbox" className="ms-4 form-check-input mt-2" />
                        </div>

                        <div className="col-md-9 mt-2">
                            <label className="form-label mb-0">Part of Shipment</label>
                            <input type="text" className="form-control form-control-sm mt-2" />
                        </div>
                       
                        <hr className='mb-1 mt-4' />

                        <div className="col-md-6 mt-2">
                            <label className="form-label mb-0">Movement Type</label>
                            <Select className="mt-2 custom-selector" options={[ { label: "Port-to-Port" ,
                                value: "Port-to-Port" }, { label: "Door-to-Door" , value: "Door-to-Door" } ]}
                                defaultValue={{ label: "Port-to-Port", value: "Port-to-Port" }} />
                        </div>

                        <div className="col-md-6 mt-2">
                            <label className="form-label mb-0">Origin</label>
                            <input type="text" className="form-control form-control-sm mt-2" />
                        </div>

                        <div className="col-md-6 mt-2">
                            <label className="form-label mb-0">Place of Receipt</label>
                            <input type="text" className="form-control form-control-sm mt-2" />
                        </div>

                        <div className="col-md-6 mt-2">
                            <label className="form-label mb-0">Loading Port</label>
                            <input type="text" className="form-control form-control-sm mt-2" />
                        </div>

                        <div className="col-md-6 mt-2">
                            <label className="form-label mb-0">Discharge Port</label>
                            <input type="text" className="form-control form-control-sm mt-2" />
                        </div>

                        <div className="col-md-6 mt-2">
                            <label className="form-label mb-0">Place of Delivery</label>
                            <input type="text" className="form-control form-control-sm mt-2" />
                        </div>

                        <div className="col-md-6 mt-2">
                            <label className="form-label mb-0">Destination</label>
                            <input type="text" className="form-control form-control-sm mt-2" />
                        </div>

                        <div className="col-md-6 mt-2">
                            <label className="form-label mb-0">Trade Lane</label>
                            <input type="text" className="form-control form-control-sm mt-2" />
                        </div>

                        <div className="col-md-6 mt-2">
                            <label className="form-label mb-0">Airline</label>
                            <input type="text" className="form-control form-control-sm mt-2" />
                        </div>

                        <div className="col-md-6 mt-2">
                            <label className="form-label mb-0">Flight No/Date</label>
                            <input type="date" className="form-control form-control-sm mt-2" />
                        </div>

                        <div className="col-md-6 mt-2">
                            <label className="form-label mb-0">Inco Terms</label>
                            <input type="text" className="form-control form-control-sm mt-2" />
                        </div>

                        <div className="col-md-6 mt-2">
                            <label className="form-label mb-0">House Freight Currency</label>
                            <Select className="mt-2 custom-selector" options={[ { label: "INR" , value: "INR" }, {
                                label: "USD" , value: "USD" } ]} defaultValue={{ label: "INR", value: "INR" }} />
                        </div>

                        <div className="col-md-6 mt-2">
                            <label className="form-label mb-0">Freight</label>
                            <Select className="mt-2 custom-selector" options={[ { label: "Collect" , value: "Collect" },
                                { label: "Prepaid" , value: "Prepaid" } ]}
                                defaultValue={{ label: "Collect", value: "Collect" }} />
                        </div>

                        <div className="col-md-6 mt-2">
                            <label className="form-label mb-0">Other Charge</label>
                            <Select className="mt-2 custom-selector" options={[ { label: "Collect" , value: "Collect" },
                                { label: "Prepaid" , value: "Prepaid" } ]}
                                defaultValue={{ label: "Collect", value: "Collect" }} />
                        </div>

                        <div className="col-md-6 mt-2">
                            <label className="form-label mb-0">Co-Load Type</label>
                            <Select className="mt-2 custom-selector" options={[ { label: "Not Applicable" ,
                                value: "Not Applicable" }, { label: "Applicable" , value: "Applicable" } ]}
                                defaultValue={{ label: "Not Applicable", value: "Not Applicable" }} />
                        </div>

                        <div className="col-md-6 mt-2">
                            <label className="form-label mb-0">Agent Name</label>
                            <input type="text" className="form-control form-control-sm mt-2" />
                        </div>

                        <div className="col-md-6 mt-2">
                            <label className="form-label mb-0">Agent AWB No/Date</label>
                            <input type="date" className="form-control form-control-sm mt-2" />
                        </div>

                        <div className="col-md-6 mt-2">
                            <label className="form-label mb-0">Remarks</label>
                            <textarea className="form-control  mt-2" rows="3"></textarea>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <div className="row justify-content-end mt-3 gap-2">
            <button className="btn btn-primary text-xs w-fit" type="submit" onClick={(e)=>{e.preventDefault()}} >
                Save
            </button>
            <button className="btn btn-primary text-xs w-fit" type="submit" onClick={(e)=>{e.preventDefault()}} >
                Save & Close
            </button>
            <button className="btn btn-primary text-xs w-fit" type="submit" onClick={(e)=>{e.preventDefault()}} >
                Save & New
            </button>
            <button className="btn btn-primary text-xs w-fit" type="submit" onClick={(e)=>{e.preventDefault()}} >
                Close
            </button>

        </div>
    </form>
</>
)
}

export default ShippingDtlsTab